import React, { Fragment, useState, useEffect, useRef } from "react";
import { TrendingUpRounded } from "@mui/icons-material";
import Loader from "react-loader-spinner";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import StudentImportConfirmation from "../../counselor/studentImportConfirmationModal/StudentImportConfirmationModal";
import Storage from "../../../services/Storage";
import "../AdminPages.css";
const API_URL = process.env.REACT_APP_API_URL;

const Import = () => {
  const [loadingForCsvDownload, setLoadingForCsvDownload] = useState(false);
  const [dataForDownload, setDataForDownload] = useState([]);
  const [
    loadingForStudentCsvDownload,
    setLoadingForStudentCsvDownload,
  ] = useState(false);
  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const [showDownload, setShowDownload] = useState(false);
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [apiCallOrNot, setApiCallOrNot] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const selectedFileRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [uploadCSVData, setUploadCSVData] = useState();

  const getSchoolsList = (value) => {
    GetAdminService.getSchoolsList(value)
      .then((data) => {
        setSchoolNameList(data?.data?.school);
        setSchoolNameLoading(false);
      })
      .catch((error) => {
        setSchoolNameLoading(false);
      });
  };

  const downLoadCsvTemplate = () => {
    setLoadingForCsvDownload(TrendingUpRounded);
    let template = [];
    template.push([
      '"Student First Name"',
      '"Student Middle Name"',
      '"Student Last Name"',
      '"Student Grade"',
      '"Student ID"',
      '"Student Email"',
      '"Student Mobile"',
      '"Student DOB"',
      '"Counselor Emails"',
    ]);
    let arr = template;
    let ret = [];
    for (let i = 0, len = arr.length; i < len; i++) {
      let line = [];
      for (let key in arr[i]) {
        if (arr[i].hasOwnProperty(key)) {
          line.push(arr[i][key]);
        }
      }
      ret.push(line.join(","));
    }
    let result_csv = ret.join("\n");
    let saving = document.createElement("a");
    saving.href = "data:attachment/csv," + encodeURIComponent(result_csv);
    saving.download = "csv_admin_import_template.csv";
    document.body.appendChild(saving);
    saving.click();
    setLoadingForCsvDownload(false);
  };

  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
}

  const getDataForCSVDownload = () => {
    setLoadingForStudentCsvDownload(true);
    GetStudentService.getStudentCountForCSVImport(
      schoolNameList[0].id
    )
      .then((data) => {
        downloadFile(data.data.download);
        setLoadingForStudentCsvDownload(false);
        // if (data.data.meta.next !== null) {
        //   data.data.objects.map((item) => {
        //     let obj = {
        //       ...item.student,
        //       ...{ counselor_email: item?.counselor?.email },
        //     };
        //     finalObj.push(obj);
        //   });
        //   setDataForDownload(finalObj);
        // } else if (data.data.meta.next === null) {
        //   data.data.objects.map((item) => {
        //     let obj = {
        //       ...item.student,
        //       ...{ counselor_email: item?.counselor?.email },
        //     };
        //     finalObj.push(obj);
        //   });
        //   let arr = [...dataForDownload, ...finalObj];
        //   setDataForDownload(arr);
        //   let result_csv = getHeaderRow();
        //   addStudentsToCsv(result_csv, arr);
        //   setLoadingForStudentCsvDownload(false);
        // }
      })
      .catch((error) => {
        setLoadingForStudentCsvDownload(false);
      });
  };

  useEffect(() => {
    if (dataForDownload.length > 0) {
      getDataForCSVDownload();
    }
  }, [dataForDownload && dataForDownload.length > 0]);

  // useEffect(() => {
  //   if (dataForDownload.length > 0) {
  //     let result_csv = getHeaderRow();
  //     addStudentsToCsv(result_csv, dataForDownload);
  //   }
  // }, [dataForDownload?.length > 0 && downloadCSVStudent === true]);

  function getHeaderRow() {
    var template = [];
    template.push([
      '"Student First Name"',
      '"Student Middle Name"',
      '"Student Last Name"',
      '"Student Grade"',
      '"Student ID"',
      '"Student Email"',
      '"Student Mobile"',
      '"Student DOB"',
      '"Counselor Emails"',
    ]);
    var arr = template;
    var ret = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      var line = [];
      for (var key in arr[i]) {
        if (arr[i].hasOwnProperty(key)) {
          line.push(arr[i][key]);
        }
      }
      ret.push(line.join(","));
    }
    return ret;
  }

  function addStudentsToCsv(csv, students) {
    var studentRecord = [];
    for (var i = 0; i < students.length; i++) {
      studentRecord[0] = students[i].first_name;
      studentRecord[1] = students[i].middle_name;
      studentRecord[2] = students[i].last_name;
      studentRecord[3] = students[i].current_grade;
      studentRecord[4] = students[i].student_id;
      studentRecord[5] = students[i].email;
      studentRecord[6] = students[i].mobile;
      studentRecord[7] = students[i].student_dob;
      studentRecord[8] = students[i].counselor_email;
      var newRow = studentRecord.join(",");
      csv.push(newRow);
    }
    var csvDownload = csv.join("\n");
    var saving = document.createElement("a");
    saving.href = "data:attachment/csv," + encodeURIComponent(csvDownload);
    saving.download = "csv_student_download.csv";
    document.body.appendChild(saving);
    saving.click();
  }

  // const uploadFileHandler = () => {
  //   let file = selectedFileRef.current.files[0];
  //   setSelectedFile(file);
  // };

  // const uploadFile = () => {
  //   let formData = new FormData();
  //   formData.append("school", schoolNameList[0]["id"]);
  //   formData.append("mode", "validation");
  //   formData.append("csv_file", selectedFile);
  //   let token = Storage.getTokenInCookie() ? Storage.getTokenInCookie() : "";
  //   fetch(`${API_URL}/api/v1/admin/upload-csv`, {
  //     method: "POST",
  //     headers: {
  //       "x-authorization": `Bearer ${token}`,
  //     },
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setUploadCSVData(data);
  //       if (data?.error_csv?.length > 0) {
  //         setShowModal(true);
  //       }
  //     })
  //     .catch((error) => {
  //     });
  // };

  // useEffect(() => {
  //   if (selectedFileRef && selectedFile) {
  //     uploadFile();
  //   }
  // }, [selectedFile]);

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
      setShowSchoolNameContainer(true);
      setSchoolNameLoading(true);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setSchoolName(item.name);
    setShowDownload(true);
  };
  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Export Students</h2>
            </div>

            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input
                  ref={schoolNameRef}
                  type="text"
                  placeholder="Type to search school name..."
                  value={schoolName}
                  onChange={handleSchoolName}
                  autoComplete="off"
                />
                {showSchoolNameContainer && (
                  <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 &&
                      schoolNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedSchoolName(item)}
                          key={index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            {showDownload && (
              <div className="admin-page-section">
                <div className="admin-page-card">
                  <p className="admin-page-section-title">Download Students</p>
                  <p className="admin-page-hint">
                    Download student data for the selected school as a CSV file.
                  </p>
                  <button
                    onClick={() => getDataForCSVDownload()}
                    className="admin-students-new-btn"
                    disabled={loadingForStudentCsvDownload}
                  >
                    Download Student
                    {loadingForStudentCsvDownload && (
                      <Loader
                        type="TailSpin"
                        color="white"
                        height={15}
                        width={15}
                      />
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
          {showModal && (
            <StudentImportConfirmation
              student={uploadCSVData}
              closeHandler={() => {
                setShowModal(false);
                selectedFileRef.current.value = null;
              }}
              isOpen={showModal}
              school_it_ok={true}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Import;
